var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-modal", {
    staticClass: "reduce-modal",
    attrs: {
      title: _vm.$t("数据导出"),
      visible: _vm.showVisible,
      width: 700,
      footer: null,
      maskClosable: false,
      closable: false
    },
    on: {
      cancel: _vm.close
    }
  }, [_c("a-spin", {
    attrs: {
      spinning: _vm.exportLoading
    }
  }, [_c("a-form", {
    attrs: {
      form: _vm.form,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("保单归属")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("保单归属"),
      "show-search": "",
      "option-filter-prop": "label"
    },
    on: {
      change: _vm.changeCustomerId
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.customerList2, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id,
        label: item.name
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "top",
        title: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1);
  }), 1)], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("保单号"),
      required: "",
      prop: "policyNo"
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请选择") + _vm.$t("保单号")
    },
    model: {
      value: _vm.form.policyNo,
      callback: function ($$v) {
        _vm.$set(_vm.form, "policyNo", $$v);
      },
      expression: "form.policyNo"
    }
  }, _vm._l(_vm.policyNoList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.policyNo
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "top",
        title: item.policyNo
      }
    }, [_vm._v(" " + _vm._s(item.policyNo) + " ")])], 1);
  }), 1)], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("批改时间"),
      required: "",
      prop: "time"
    }
  }, [_c("a-range-picker", {
    attrs: {
      format: _vm.getFormatDate()
    },
    model: {
      value: _vm.form.time,
      callback: function ($$v) {
        _vm.$set(_vm.form, "time", $$v);
      },
      expression: "form.time"
    }
  })], 1)], 1), _c("div", {
    staticClass: "btn-box"
  }, [_vm.isAuth("customer.personnelDetailsRecordEndorsementExport") || _vm.isAuth("customer.personnelDetailsRecordCheckEndorsementExport") || _vm.isAuth("customer.personnelDetailsRecordEndorsementExportSend") ? _c("div", {
    staticClass: "detail-icon border-right-class"
  }, [_c("span", {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(_vm.$t("批单")))]), _c("a-icon", {
    staticStyle: {
      "font-size": "45px",
      margin: "20px 0"
    },
    attrs: {
      type: "file-text"
    }
  }), _c("div", [_vm.isAuth("customer.personnelDetailsRecordCheckEndorsementExport") ? _c("a-button", {
    on: {
      click: _vm.preview
    }
  }, [_vm._v(_vm._s(_vm.$t("预览批单")))]) : _vm._e(), _c("a-dropdown", {
    scopedSlots: _vm._u([{
      key: "overlay",
      fn: function () {
        return [_c("a-menu", {
          on: {
            click: _vm.handleMenuClick
          }
        }, [_vm.isAuth("customer.personnelDetailsRecordEndorsementExport") ? _c("a-menu-item", {
          key: "create"
        }, [_vm._v(_vm._s(_vm.$t("生成批单")))]) : _vm._e(), _vm.isAuth("customer.personnelDetailsRecordEndorsementExportSend") ? _c("a-menu-item", {
          key: "createAndSend"
        }, [_vm._v(_vm._s(_vm.$t("生成并发送")))]) : _vm._e()], 1)];
      },
      proxy: true
    }], null, false, 1675334371)
  }, [_vm.isAuth("customer.personnelDetailsRecordEndorsementExport") || _vm.isAuth("customer.personnelDetailsRecordEndorsementExportSend") ? _c("a-button", {
    staticClass: "marginL15"
  }, [_vm._v(" " + _vm._s(_vm.$t("生成批单")) + " "), _c("a-icon", {
    attrs: {
      type: "down"
    }
  })], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _c("div", {
    staticClass: "detail-icon"
  }, [_c("span", {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(_vm.$t("增减员明细")))]), _c("a-icon", {
    staticStyle: {
      "font-size": "45px",
      margin: "20px 0"
    },
    attrs: {
      type: "file-excel"
    }
  }), _c("div", [_c("a-button", {
    on: {
      click: _vm.onExport
    }
  }, [_vm._v(_vm._s(_vm.$t("导出明细")))])], 1)], 1)]), _vm.isAuth("customer.personnelDetailsRecordExportSendEmail") ? _c("div", {
    staticClass: "send-email"
  }, [_c("div", [!_vm.isSendEmailShow ? _c("a-button", {
    staticClass: "marginR15",
    on: {
      click: _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))]) : _vm._e(), _c("a-button", {
    staticClass: "send-email-button",
    on: {
      click: _vm.changeShow
    }
  }, [_vm._v(_vm._s(_vm.$t("转发到邮箱")))])], 1), _vm.isSendEmailShow ? _c("div", {
    staticClass: "send-email-data"
  }, [_c("a-form-item", {
    staticClass: "send-email-info",
    attrs: {
      label: _vm.$t("接收邮箱"),
      required: "",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 16
      },
      prop: "receivingEmails"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入邮箱地址，多个邮箱中间用“,”(英文逗号)隔开"),
      allowClear: ""
    },
    model: {
      value: _vm.receivingEmails,
      callback: function ($$v) {
        _vm.receivingEmails = $$v;
      },
      expression: "receivingEmails"
    }
  })], 1), _c("a-form-item", {
    staticClass: "send-email-info",
    attrs: {
      label: _vm.$t("文件类型"),
      "label-col": {
        span: 5
      },
      required: "",
      "wrapper-col": {
        span: 16
      }
    }
  }, [_vm.isAuth("customer.personnelDetailsRecordEndorsementExport") || _vm.isAuth("customer.personnelDetailsRecordCheckEndorsementExport") || _vm.isAuth("customer.personnelDetailsRecordEndorsementExportSend") ? _c("a-checkbox", {
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      checked: _vm.checkTypeOne
    },
    on: {
      change: _vm.onCheckTypeOne
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("批单")) + " ")]) : _vm._e(), _c("a-checkbox", {
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      checked: _vm.checkTypeTwo
    },
    on: {
      change: _vm.onCheckTypeTwo
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("增减员明细表")) + " ")])], 1), _c("div", [_c("a-button", {
    staticClass: "marginR15",
    on: {
      click: _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))]), _c("a-button", {
    staticClass: "send-email-button ant-btn-primary marginR15",
    on: {
      click: _vm.sendEmail
    }
  }, [_vm._v(_vm._s(_vm.$t("发送")))])], 1)], 1) : _vm._e()]) : _c("div", {
    staticClass: "btns"
  }, [_c("a-button", {
    on: {
      click: _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)], 1)], 1), _c("a-modal", {
    staticClass: "reduce-modal",
    attrs: {
      title: _vm.$t("信息提示"),
      visible: _vm.tipVisible,
      width: 700,
      cancelText: _vm.requestInfo.type === "createAndSend" && _vm.loading === false ? _vm.$t("立即查看") : "",
      okText: _vm.$t("关闭"),
      closable: false,
      maskClosable: false,
      cancelButtonProps: _vm.requestInfo.type === "create" || _vm.requestInfo.type === "preview" || _vm.loading === true || _vm.importStatus !== "SUCCESS" ? {
        style: {
          display: "none"
        }
      } : {}
    },
    on: {
      cancel: _vm.tipChange,
      ok: function ($event) {
        _vm.tipVisible = false;
      }
    }
  }, [_vm.loading ? _c("div", {
    staticClass: "example"
  }, [_c("a-spin", {
    attrs: {
      tip: _vm.$t(_vm.requestInfo.loadingTip)
    }
  })], 1) : _c("div", {
    staticClass: "complete-tip"
  }, [_c("a-icon", {
    class: _vm.importStatus === "SUCCESS" ? "complate-icon" : "error-icon",
    attrs: {
      type: "check-circle"
    }
  }), _c("div", {
    staticClass: "msg"
  }, [_vm._v(_vm._s(_vm.$t(_vm.completeTitle)))])], 1)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };